import { Table } from 'components/shared/Table';
import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import { IntegrationSettingsEntry, IntegrationSettingsLocationLevelForm } from 'modules/integrationSettings/types';
import { IntegrationSettingsTypedInput } from '../typedInput';
import { MultiSelectFilter } from 'components/Table/Filters/ColumnMultiSelectFilter';
import { searchFilterByColumn } from 'components/Table/lib/searchFilters';
import { Column } from 'react-table';

interface Props {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsLocationLevelForm[];
}

export const IntegrationSettingsTable = ({ integrationSettings, tableData }: Props) => {
  const columns: Column<IntegrationSettingsLocationLevelForm>[] = [
    {
      Header: 'Type',
      accessor: 'category',
      width: 150,
      filterable: true,
      filterMethod: searchFilterByColumn,
      Cell: ({ original }: any) => <SimpleTextCell value={original.category} />,
      Filter: ({ filter, onChange, column }: any) => (
        <MultiSelectFilter
          filter={filter}
          defaultFilter={{ value: ['Branch'] }}
          onChange={onChange}
          column={column}
          rows={tableData || []}
        />
      ),
    },
    {
      Header: 'Name',
      accessor: 'locationName',
      Cell: ({ original }: any) => <SimpleTextCell value={original.locationName} />,
    },
    {
      Header: 'Address',
      accessor: 'address',
      Cell: ({ original }: any) => <SimpleTextCell value={original.address} />,
      width: 100,
    },
    ...integrationSettings.map(setting => ({
      accessor: setting.name,
      Header: setting.displayName,
      Cell: ({ original, index }: any) => (
        <IntegrationSettingsTypedInput
          key={original.locationId}
          dataKey={original.locationId}
          integrationSettingsEntry={setting}
        />
      ),
      filterable: false,
      sortable: false,
    })),
  ].map(header => ({
    ...header,
    resizable: false,
    headerClassName: 'customHeader',
  }));

  return (
    <Table<IntegrationSettingsLocationLevelForm>
      tableData={tableData}
      columns={columns}
      paginationOptions={{ pageSize: tableData.length > 20 ? 20 : tableData.length }}
    />
  );
};
